import getStore from "../store/store";

export function getIsCommandCenterVisible(): boolean {
    return getStore().isCommandCenterVisible;
}
